import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { OKTA_AUTH } from './okta-auth.token';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Only add auth header to relative URLs (API calls)
  if (req.url.startsWith('http://') || req.url.startsWith('https://')) {
    return next(req);
  }

  const oktaAuth = inject(OKTA_AUTH);

  return from(oktaAuth.getOrRenewAccessToken()).pipe(
    switchMap((accessToken) => {
      if (accessToken) {
        req = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
        });
      }
      return next(req);
    })
  );
};
